import { useStaticQuery, graphql } from "gatsby"

const upcomingEventsQuery = graphql`
  query UpcomingEventsQuery {
    allCraftEventDefaultEntry {
      nodes {
        ...eventEntry
      }
    }
  }
`

/**
 * Get Craft's mainNav top level data, with nested entries
 */
export const useUpcomingEvents = () => {
  const { allCraftEventDefaultEntry } = useStaticQuery(upcomingEventsQuery)

  return allCraftEventDefaultEntry?.nodes
}
